module.exports = __webpack_public_path__ + "media/images/covid/teaser_title-f06dd6779bda3b57a021dd8d318d042b.png";